export default __webpack_public_path__ + "static/media/satiety.a7f9d988.svg";